import {
  DonationPaymentMethod,
  isManualPaymentNoLogo,
  isPayTrCardPayment,
} from './donationCardsLogoUtils';
import { ProjectDonationStatus } from './projectDonationConstants';

const matchesDonation = (row, donationId) => {
  if (!donationId || !row) return false;
  return row.sourceId === donationId
    || row.parentSourceId === donationId
    || row.externalSourceId === donationId;
};

export const resolveProjectDonationLogoInfo = (detail, ledgerRows = []) => {
  if (!detail) {
    return {
      debtSlipNo: null,
      collectionSlipNo: null,
      showLogoSection: false,
      showPendingWarning: false,
      showManualNote: false,
      isPayTr: false,
    };
  }

  const paymentMethod = detail.paymentMethod;
  const isPayTr = isPayTrCardPayment(paymentMethod) || Boolean(detail.payTrMerchantOid);
  const isManual = isManualPaymentNoLogo(paymentMethod);
  const relatedRows = Array.isArray(ledgerRows)
    ? ledgerRows.filter((row) => matchesDonation(row, detail.id))
    : [];

  const debtFromLedger = relatedRows.find(
    (row) => row.externalReference && (row.debitAmount > 0 || row.ledgerKind === 0),
  )?.externalReference;

  const debtSlipNo = detail.lastLogoDebtSlipNo
    || detail.logoDebtSlipNo
    || debtFromLedger
    || null;

  const collectionSlipNo = detail.externalReference
    || detail.paymentExternalReference
    || null;

  const showPendingWarning = detail.status === ProjectDonationStatus.Pending
    && isPayTr
    && (detail.payTrCallbackReceivedAt || detail.payTrMerchantOid)
    && !collectionSlipNo;

  const showManualNote = isManual;
  const showLogoSection = detail.status === ProjectDonationStatus.Paid
    && (isPayTr || collectionSlipNo || debtSlipNo);

  return {
    debtSlipNo,
    collectionSlipNo,
    showLogoSection,
    showPendingWarning,
    showManualNote,
    isPayTr,
  };
};

export { DonationPaymentMethod as ProjectPaymentMethod };
